import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Input,
    InputGroup, Label, Spinner, ModalBody, ModalFooter, Modal,
    InputGroupText,
    Row,
    Col,
} from "reactstrap";
import { NavLink as NavLinkRRD, Link, Redirect, useHistory } from "react-router-dom";
import { Form, Field } from "react-final-form";
import dataProvider from 'dataProvider';
import Settings from "./settings/settings";



const Forgetpassword = () => {
    const history = useHistory();
    const [existmodal, setExistmodal] = useState(false);
    const [next, setNext] = useState(false);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [validotpmodal, setValidotpmodal] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [sucess, setSucess] = useState(false);

    const Closemodal = () => {
        setModalOpen(false);
    }
    const Closeotpmodal = () => {
        setValidotpmodal(false);
    }
    const Close_existmodal = () => {
        setExistmodal(false);
    }

    const onSubmit = (values) => {
        setLoading(true)
        dataProvider.create('users/forgot-password', { ...values })
            .then(({ data }) => {
                setNext(data.status)
                setLoading(false)
            })
            .catch(error => {
                if (error.response.data.message === 'User Not Exist') {
                    setExistmodal(true);
                }
                setLoading(false)
            });
    }
    const onSubmit_update = (val) => {
        if (val.confirm_pswrd === val.new_pswrd) {
            dataProvider.create('users/reset-password', { email: val.email, token: val.otp, password: val.new_pswrd })
                .then(({ data }) => {
                    history.push('./login')
                    // if (data?.status === true) {
                    //     setSucess(true)
                    //     setTimeout(() => Push(), 1000);

                    // }
                })
                .catch(error => {
                    if (error.response.data.message === 'OTP is not valid!') {
                        setValidotpmodal(true);
                    }

                });

        } else {
            setModalOpen(true);
        }
    }
    const mustBeNumber = value => (isNaN(value) ? 'Must be a number' : undefined)
    return (
        <>
            {next ? (
                <Col lg="6" md="8">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-5">
                            <div className="text-muted text-center mt-2 mb-4">
                                <small>Forgot Password</small>
                            </div>
                            <div className="text-center">
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <Form
                                onSubmit={onSubmit_update}
                                validate={values => {
                                    const errors = {};
                                    if (!values.new_pswrd) {
                                        errors.new_pswrd = "Required";
                                    }
                                    if (!values.confirm_pswrd) {
                                        errors.confirm_pswrd = "Required";
                                    }
                                    return errors;
                                }}
                                render={({ handleSubmit }) => (
                                    <form onSubmit={handleSubmit} style={{ padding: '10px' }}>
                                        <div className="pl-lg-4">
                                            <Row>
                                                <Col lg="12">
                                                    <FormGroup>
                                                        <Label style={{ fontSize: ' 0.8125rem' }} >Enter OTP</Label>
                                                        <Field name="otp" validate={mustBeNumber} >
                                                            {({ input, meta }) => (
                                                                <div>
                                                                    <Input
                                                                        {...input}
                                                                        style={{ color: 'black' }}
                                                                        type="text"
                                                                    />
                                                                    {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                                                </div>
                                                            )}
                                                        </Field>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="12">
                                                    <FormGroup>
                                                        <Label style={{ fontSize: ' 0.8125rem' }} for="password">Enter New Password</Label>
                                                        <Field name="new_pswrd" >
                                                            {({ input, meta }) => (
                                                                <div>
                                                                    <Input
                                                                        {...input}
                                                                        style={{ color: 'black' }}
                                                                        type="text"
                                                                    />
                                                                    {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                                                </div>
                                                            )}
                                                        </Field>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="12">
                                                    <FormGroup>
                                                        <Label style={{ fontSize: ' 0.8125rem' }} for="email">Confirm Password</Label>
                                                        <Field name="confirm_pswrd"  >
                                                            {({ input, meta }) => (
                                                                <div>
                                                                    <Input
                                                                        {...input}
                                                                        style={{ color: 'black' }}
                                                                        type="text"
                                                                    />
                                                                    {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                                                </div>
                                                            )}
                                                        </Field>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                                            <Button type="submit" style={{ backgroundColor: 'rgb(4 64 87)', color: 'white', width: '50%', border: 0 }}>
                                                RESET PASSWORD
                                            </Button>{' '}
                                        </div>
                                    </form>
                                )}
                            />
                        </CardBody>
                    </Card>
                    <Row>
                        <Col xs="6" style={{ marginTop: 20 }}>
                            <a
                                className="text-light"
                                href="#pablo"
                            >
                                <Link to="/login"><small style={{ color: 'white' }}>Back to Login?</small></Link>
                            </a>
                        </Col>
                    </Row>
                </Col>) :
                (<Col lg="6" md="8">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-4">
                            <div className="text-muted text-center mt-2 mb-4">
                                <small>Forgot Password</small>
                            </div>
                            <div className="text-center">
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-4 py-lg-4" >
                            <Form
                                onSubmit={onSubmit}
                                validate={values => {
                                    const errors = {};
                                    function validateEmail(email) {
                                        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                        return re.test(String(email).toLowerCase());
                                    }
                                    if (!values.email) {
                                        errors.email = "Required";
                                    } else if (!validateEmail(values.email)) {
                                        errors.email = "Enter a valid email address";
                                    }
                                    return errors;
                                }}
                                render={({ handleSubmit }) => (
                                    <form onSubmit={handleSubmit} style={{ padding: '10px' }}>
                                        <div className="pl-lg-4">
                                            <Row>
                                                <Col lg="12">
                                                    <FormGroup>
                                                        <Label style={{ fontSize: ' 0.8125rem' }} for="email">Enter Your Email </Label>
                                                        <Field name="email" >
                                                            {({ input, meta }) => (
                                                                <div>
                                                                    <Input
                                                                        {...input}
                                                                        style={{ color: 'black' }}
                                                                        type="text"
                                                                        placeholder="Enter Email Address"

                                                                    />
                                                                    {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                                                </div>
                                                            )}
                                                        </Field>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: loading ? 'green' : '#09577C', marginLeft: '10px', color: 'white', width: '50%', borderRadius: '10px' }} >
                                                {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                                                SUBMIT
                                            </Button>{' '}
                                        </div>
                                    </form>
                                )}
                            />
                        </CardBody>
                    </Card>
                    <Row>
                        <Col xs="6" style={{ marginTop: 20 }}>
                            <a
                                className="text-light"
                                href="#pablo"
                            >
                                <Link to="/login"><small style={{ color: 'white' }}>Back to Login?</small></Link>
                            </a>
                        </Col>
                    </Row>
                </Col>)}

            <Modal isOpen={modalOpen} size="sm">
                <div style={{ color: 'red', padding: 10, marginTop: 10 }}> password and confirmation password didn't match..!</div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button onClick={() => Closemodal()} style={{ backgroundColor: '#fe727d', color: 'white', marginBottom: 20, border: 0 }} type="button">
                        OK
                    </Button>
                </div>
            </Modal>
            <Modal isOpen={validotpmodal} size="sm">
                <ModalBody style={{ color: 'red' }}> Enter a valid OTP..!</ModalBody>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button onClick={() => Closeotpmodal()} style={{ backgroundColor: '#fe727d', color: 'white', marginBottom: 20, border: 0 }} type="button">
                        OK
                    </Button>
                </div>
            </Modal>
            <Modal isOpen={existmodal} size="sm">
                <ModalBody style={{ color: 'red' }}> User Not Exist..!</ModalBody>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button onClick={() => Close_existmodal()} style={{ backgroundColor: '#fe727d', color: 'white', marginBottom: 20, border: 0 }} type="button">
                        OK
                    </Button>
                </div>
            </Modal>
            <Modal isOpen={sucess} size="sm">
                <ModalBody style={{ color: 'green' }}> Password reset successfully..!</ModalBody>
            </Modal>
        </>
    );
};

export default Forgetpassword;